export default "__VITE_ASSET__4PQgIu3S__"